import { ca } from '@cian/analytics';
import { EFrequency } from '@cian/save-search-widget';

interface ITrackSubscribedParameters {
  frequency: EFrequency;
  subscribeToNews: boolean;
  title?: string;
  email?: string;
  defaultTitle?: string;
  defaultEmail?: string | null;
}

const notificationFrequencyMap: { [key in EFrequency]: string } = {
  [EFrequency.Asap]: 'Asap',
  [EFrequency.Hourly]: 'Hourly',
  [EFrequency.Daily]: 'Daily',
  [EFrequency.Weekly]: 'Weekly',
};

export function trackSubscribed({ frequency, subscribeToNews }: ITrackSubscribedParameters) {
  let label = 'From_card_save';

  label += `/${notificationFrequencyMap[frequency]}`;

  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',
    label,
  });

  if (subscribeToNews) {
    ca('eventSite', {
      name: 'oldevent',
      action: 'Send',
      category: 'subscription',
      label: 'news_From_cat_save',
    });
  }
}
